import { ref as f, computed as P, onMounted as V, onBeforeUnmount as x, watch as M, resolveComponent as k, openBlock as m, createElementBlock as E, normalizeClass as l, renderSlot as h, createTextVNode as u, withDirectives as y, createVNode as v, withModifiers as B, withCtx as L, createElementVNode as z, createCommentVNode as b, vShow as S, unref as T } from "vue";
import { useElementHover as O } from "./design-system.es125.js";
import U from "./design-system.es58.js";
import j from "./design-system.es146.js";
/* empty css                    */
import q from "./design-system.es128.js";
/* empty css                    */
import A from "./design-system.es62.js";
/* empty css                    */
import { targetContainsClickEvent as F } from "./design-system.es140.js";
/* empty css                    */
const G = {
  name: "DsEditable",
  components: {
    Icon: U,
    Inline: A
  },
  props: {
    isEditing: Boolean,
    disabled: Boolean,
    hideIcon: Boolean,
    iconEdit: Boolean,
    alwaysShowIcon: Boolean,
    hasPlaceholder: Boolean,
    text: [String, Number]
  },
  emits: [
    "cancel",
    "edit",
    "save",
    "try-edit"
  ],
  setup(o, { emit: e }) {
    const { isTouchDevice: t } = j(), n = f(null), d = f(null), r = f(null), a = O(n), c = P(() => !o.disabled && !o.hideIcon);
    function s(i) {
      F(i, T(n)) || e("save");
    }
    function H() {
      T(t) && window.addEventListener("touchend", s, !0), window.addEventListener("click", s, !0);
    }
    function w() {
      window.removeEventListener("touchend", s, !0), window.removeEventListener("click", s, !0);
    }
    function N() {
      e("cancel");
    }
    function g() {
      e("edit");
    }
    function I() {
      e("try-edit");
    }
    function C(i) {
      i.stopPropagation(), I();
    }
    function p(i) {
      i.preventDefault(), i.stopPropagation(), g();
    }
    function _() {
      d.value && d.value.addEventListener("touchstart", C), r.value && r.value.addEventListener("touchstart", p);
    }
    function D() {
      d.value && d.value.removeEventListener("touchstart", C), r.value && r.value.removeEventListener("touchstart", p);
    }
    return V(() => {
      _();
    }), x(() => {
      w(), D();
    }), M(() => o.isEditing, (i) => {
      i ? H() : w();
    }), {
      isTouchDevice: t,
      el: n,
      notEditingContainer: d,
      iconContainer: r,
      isHovered: a,
      showEditIcon: c,
      cancel: N,
      edit: g,
      tryEdit: I
    };
  }
}, J = {
  ref: "notEditingContainer",
  class: "not-editing-container"
};
function K(o, e, t, n, d, r) {
  const a = k("Icon"), c = k("Inline");
  return m(), E("div", {
    ref: "el",
    class: l(["editable", {
      active: t.isEditing,
      "editable-hovered": n.isHovered
    }])
  }, [
    h(o.$slots, "dimensions", {}, void 0, !0),
    e[3] || (e[3] = u()),
    y(v(c, {
      "align-y": "center",
      space: "spacing-200",
      class: l(["not-editing", [t.iconEdit ? "icon-edit" : "not-editing", { "placeholder-edit": t.iconEdit && t.hasPlaceholder }]]),
      onClick: B(n.tryEdit, ["stop"])
    }, {
      default: L(() => [
        z("div", J, [
          h(o.$slots, "not-editing", {}, void 0, !0)
        ], 512),
        e[1] || (e[1] = u()),
        n.showEditIcon ? (m(), E("span", {
          key: 0,
          class: l(["edit-icon", { "edit-icon-visible": n.isHovered || t.alwaysShowIcon }]),
          onClick: e[0] || (e[0] = B((...s) => n.edit && n.edit(...s), ["prevent", "stop"]))
        }, [
          v(a, { name: "edit" })
        ], 2)) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "onClick"]), [
      [S, !t.isEditing]
    ]),
    e[4] || (e[4] = u()),
    y(v(c, {
      "align-y": "center",
      space: "spacing-200",
      class: "editing-container"
    }, {
      default: L(() => [
        h(o.$slots, "editing", {}, void 0, !0),
        e[2] || (e[2] = u()),
        n.showEditIcon ? (m(), E("span", {
          key: 0,
          class: l(["edit-icon", { "edit-icon-visible": n.isHovered || t.alwaysShowIcon }])
        }, [
          v(a, { name: "edit" })
        ], 2)) : b("", !0)
      ]),
      _: 3
    }, 512), [
      [S, t.isEditing]
    ])
  ], 2);
}
const oe = /* @__PURE__ */ q(G, [["render", K], ["__scopeId", "data-v-fda26283"]]);
export {
  oe as default
};
//# sourceMappingURL=design-system.es52.js.map
